import { bigint, coerce, integer, number, string } from 'superstruct';

import { withMessage } from './withMessage';

/**
 * Allow parsable strings to be accepted for an integer.
 * Requires coercion to be set.
 */
export const parsableInteger = () =>
	coerce(integer(), string(), (value) =>
		value === '' || value === 'null' ? null : Number.parseInt(value)
	);

export function parsableFloat() {
	return withMessage(
		coerce(number(), string(), (value) => {
			if (value === '' || value === 'null') {
				return null;
			}

			const parsed = Number.parseFloat(value);

			// If we could not parse the value, return the original value so that errors
			// will report with the original value.
			if (Number.isNaN(parsed)) {
				return value;
			}

			return parsed;
		}),
		'Invalid number'
	);
}

export const parsableBigInt = () =>
	coerce(bigint(), string(), (value) =>
		value === '' || value === 'null' ? null : BigInt(value)
	);
